import type { DebugOption } from "@v2/features/debug/debugOptions";

type DebugOptionStorageEffect = {
  shouldReload: boolean;
};

export function getDebugOptionStorageEffect({
  option,
}: {
  option: DebugOption;
  nextValue: unknown;
}): DebugOptionStorageEffect {
  return {
    shouldReload: option.refreshOnChange === true,
  };
}

export function applyDebugOptionStorageEffect(
  effect: DebugOptionStorageEffect,
) {
  if (effect.shouldReload) {
    window.location.reload();
  }
}
